import type { CSSProperties, FC } from "react";
import Stack, { type StackProps } from "../Stack";

type Props = StackProps & {
  inline?: boolean;
  flexWrap?: string;
  fullWidth?: boolean;
  center?: boolean;
};

const FlexStack: FC<Props> = ({
  inline,
  flexWrap,
  fullWidth,
  center,
  style,
  ...props
}) => (
  <Stack
    style={{
      display: "flex",
      flexDirection: inline ? "row" : "column",
      ...(flexWrap && { flexWrap: flexWrap as CSSProperties["flexWrap"] }),
      ...(fullWidth && { width: "100%" }),
      ...(center && { alignItems: "center", justifyContent: "center" }),
      ...style,
    }}
    {...props}
  />
);

export default FlexStack;
